export default __webpack_public_path__ + "static/char-v-sp01-b168722edb5572d9fd3ebdea3030e522.webp";